import axios from 'axios';
import CONSTS from '../../config/constants';
import Env from '../../config/environment';

const env = Env();
const version = env.app.version;
const { API_APP } = CONSTS.SERVICES;

export const sendMail = (email, payment) => axios.post('/b/send_mail', {
  email: email,
  payment: payment,
});

export const resendMail = (data) => axios.post(`/b/private/${version}/admin/mail`, {
  ...data
}, {
  headers: {
    service: API_APP,
  },
});